// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"send-application-module--formGroup--3Ia4f","activeLabel":"send-application-module--activeLabel--1dMrw","normalLabel":"send-application-module--normalLabel--2fTqm"};